<template>
  <b-nav-item-dropdown right class="dd-lang">
    <template slot="button-content">
      <div class="flag flag-selected" v-html="selectedFlag"></div> <span class="selected-lang">{{ selectedLang }}</span>
    </template>
    <b-dropdown-item class="language-drop-down" @click="setLang('en')"><div class="flag" v-html="svg.en"></div> English </b-dropdown-item>
    <b-dropdown-item class="language-drop-down" @click="setLang('fr')"><div class="flag" v-html="svg.fr"></div> Français </b-dropdown-item>
    <b-dropdown-item class="language-drop-down" @click="setLang('es')"><div class="flag" v-html="svg.es"></div> Español </b-dropdown-item>
  </b-nav-item-dropdown>
</template>
<script>
  import svg from '../../_svg.js'
  export default {
    name: 'language-dropdown',
    data () {
      return {
        langMaps: { 'en': 'English', 'fr': 'Français', 'es': 'Español' },
        svg: svg
      }
    },
    methods: {
      setLang (lang) {
        this.$i18n.set(lang)
        window.localStorage.setItem('lang', lang)
      },
      getLang () {
        return this.$i18n.locale() || 'en'
      }
    },
    computed: {
      selectedLang () {
        return this.langMaps[this.getLang()]
      },
      selectedFlag () {
        return this.svg[this.getLang()]
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Header/Language.vue